import { Analytics } from 'constants/index'
import { AnalyticsProps } from 'typings'
import { RecoverStep } from 'typings/recoverpassword'

export const InitialTrackedSteps: Record<RecoverStep, AnalyticsProps> = {
    [RecoverStep.selectContact]: {
        ...Analytics.RecoverPasswordSteps.SelectContact,
    },
    [RecoverStep.validateToken]: {
        ...Analytics.RecoverPasswordSteps.ValidateToken,
    },
    [RecoverStep.newPassword]: {
        ...Analytics.RecoverPasswordSteps.NewPassword,
    },
}

export const InitialTrackedPageView: Record<RecoverStep, AnalyticsProps> = {
    [RecoverStep.selectContact]: {
        ...Analytics.RecoverPasswordPageView.SelectContact,
    },
    [RecoverStep.validateToken]: {
        ...Analytics.RecoverPasswordPageView.ValidateToken,
    },
    [RecoverStep.newPassword]: {
        ...Analytics.RecoverPasswordPageView.NewPassword,
    },
}
